import * as Loaders from "react-spinners";

const componentsObject = { ...Loaders };

type LoaderType = keyof typeof componentsObject;

interface Props {
  type?: LoaderType;
  color?: string;
  size?: number;
}

const Spinner: React.FC<Props> = ({ type = "BarLoader", ...props }) => {
  const Component = componentsObject[type] as any; // currently assigning type as "any" as not found a way to type guard the component's type properly

  return Component && <Component {...props} />;
};

export default Spinner;
